export default {
    GET_DECLARE:(state)=>{
        return state.declareCompany
    },
    GET_BIRTH_COUNTRY_DIRECTOR: (state)=> {
        return state.birthCountryDirector
    }
   
}